export const CONFIRMED_GET_PATIENT_CURED_DISEASES =
  "CONFIRMED_GET_PATIENT_CURED_DISEASES";
export const CONFIRMED_UPDATE_PATIENT_CURED_DISEASES =
  "CONFIRMED_UPDATE_PATIENT_CURED_DISEASES";

